import { RefreshMatchingActivityParams } from "PFCore/services/matching_activities/refresh_matching_activity";

export const mutationKeys = {
  refreshMatchingActivity: (params: RefreshMatchingActivityParams) => ["refreshMatchingActivity", params],
  transfer: () => ["transfer"]
};
